/*
 @Traducido por Vicente Adria Bohigues - vicenteadria@hotmail.com
 */

const locale: IGanttLocale = {
	date: {
		month_full: ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"],
		month_short: ["Gen", "Feb", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Des"],
		day_full: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"],
		day_short: ["Dg", "Dl", "Dm", "Dc", "Dj", "Dv", "Ds"]
	},
	labels: {
		new_task: "Nova tasca",
		icon_save: "Guardar",
		icon_cancel: "Cancel·lar",
		icon_details: "Detalls",
		icon_edit: "Editar",
		icon_delete: "Esborrar",
		confirm_closing: "", // "Els seus canvis es perdràn, continuar ?"
		confirm_deleting: "L'esdeveniment s'esborrarà definitivament, continuar ?",
		section_description: "Descripció",
		section_time: "Periode de temps",
		section_type: "Type",
		/* grid columns */

		column_wbs: "WBS",
		column_text: "Task name",
		column_start_date: "Start time",
		column_duration: "Duration",
		column_add: "",

		/* link confirmation */
		link: "Link",
		confirm_link_deleting: "will be deleted",
		link_start: " (start)",
		link_end: " (end)",

		type_task: "Task",
		type_project: "Project",
		type_milestone: "Milestone",


		minutes: "Minutes",
		hours: "Hours",
		days: "Days",
		weeks: "Week",
		months: "Months",
		years: "Years",

		/* message popup */
		message_ok: "OK",
		message_cancel: "Cancel·lar",

		/* constraints */
		section_constraint: "Constraint",
		constraint_type: "Constraint type",
		constraint_date: "Constraint date",
		asap: "As Soon As Possible",
		alap: "As Late As Possible",
		snet: "Start No Earlier Than",
		snlt: "Start No Later Than",
		fnet: "Finish No Earlier Than",
		fnlt: "Finish No Later Than",
		mso: "Must Start On",
		mfo: "Must Finish On",

		/* resource control */
		resources_filter_placeholder: "type to filter",
		resources_filter_label: "hide empty"
	}
};

export default locale;